module.exports = __webpack_public_path__ + "img/v2_header_with_logo.0bb931fe.png";